export enum FileType {
  TEXT = 'text',
  JSON = 'json',
  AUDIO = 'audio',
  VIDEO = 'video',
  IMAGE = 'image',
  UNKNOWN = 'unknown'
}

const fileExtensions: Record<string, FileType> = {
  // Text files
  'txt': FileType.TEXT,
  'md': FileType.TEXT,
  'log': FileType.TEXT,
  'csv': FileType.TEXT,
  'tsv': FileType.TEXT,
  'srt': FileType.TEXT,
  'vtt': FileType.TEXT,
  
  // JSON files
  'json': FileType.JSON,
  'jsonl': FileType.JSON,
  
  // Audio files
  'mp3': FileType.AUDIO,
  'wav': FileType.AUDIO,
  'flac': FileType.AUDIO,
  'ogg': FileType.AUDIO,
  'aac': FileType.AUDIO,
  'm4a': FileType.AUDIO,
  
  // Video files
  'mp4': FileType.VIDEO,
  'avi': FileType.VIDEO,
  'mov': FileType.VIDEO,
  'mkv': FileType.VIDEO,
  'webm': FileType.VIDEO,
  'flv': FileType.VIDEO,
  'm4v': FileType.VIDEO,
  
  // Image files
  'jpg': FileType.IMAGE,
  'jpeg': FileType.IMAGE,
  'png': FileType.IMAGE,
  'gif': FileType.IMAGE,
  'svg': FileType.IMAGE,
  'webp': FileType.IMAGE,
  'bmp': FileType.IMAGE,
};

export const getFileType = (fileName: string): FileType => {
  const extension = fileName.split('.').pop()?.toLowerCase();
  if (!extension) return FileType.UNKNOWN;
  
  return fileExtensions[extension] || FileType.UNKNOWN;
};

export const getFileIcon = (fileType: FileType): string => {
  switch (fileType) {
    case FileType.TEXT: return '📄';
    case FileType.JSON: return '📋';
    case FileType.AUDIO: return '🎵';
    case FileType.VIDEO: return '🎬';
    case FileType.IMAGE: return '🖼️';
    default: return '📄';
  }
};

export const canEdit = (fileType: FileType): boolean => {
  return fileType === FileType.TEXT || fileType === FileType.JSON;
};

export const needsPlayer = (fileType: FileType): boolean => {
  return fileType === FileType.AUDIO || fileType === FileType.VIDEO;
};